import { render, staticRenderFns } from "./PopupWarning.vue?vue&type=template&id=623b81e6"
import script from "./PopupWarning.vue?vue&type=script&lang=js"
export * from "./PopupWarning.vue?vue&type=script&lang=js"
import style0 from "./PopupWarning.vue?vue&type=style&index=0&id=623b81e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports